import { render, staticRenderFns } from "./Jiuzhang.vue?vue&type=template&id=6cdf0bab&"
import script from "./Jiuzhang.vue?vue&type=script&lang=js&"
export * from "./Jiuzhang.vue?vue&type=script&lang=js&"
import style0 from "./Jiuzhang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports